import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import DeleteUserDialog from "./DeleteUserDialog";
import UserTable from "./UserTable";
import MemberFormDialog from "./MemberFormDialog";
import ResetPasswordDialog from "./ResetPasswordDialog";
import { Button } from "@/components/ui/button";

export default function MemberUsersSection() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formOpen, setFormOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    const { data } = await api.get("/admin/users/members");
    setUsers(data.users);
  };

  useEffect(() => {
    load().catch(() => toast.error("Gagal memuat daftar member")).finally(() => setLoading(false));
  }, []);

  const remove = async (account) => {
    try {
      await api.delete(`/admin/users/members/${account.id}`);
      toast.success("Member dihapus");
      await load();
    } catch (error) {
      toast.error(formatApiErrorDetail(error.response?.data?.detail));
    }
  };

  const save = async (values) => {
    setSaving(true);
    try {
      if (selected) await api.patch(`/admin/users/members/${selected.id}`, values);
      else await api.post("/admin/users/members", values);
      toast.success(selected ? "Member diperbarui" : "Akun departemen ditambahkan");
      setFormOpen(false); await load();
    } catch (error) { toast.error(formatApiErrorDetail(error.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <section className="border border-border bg-card p-4 sm:p-6">
      <div className="mb-5">
        <h2 className="font-heading font-bold text-lg flex items-center gap-2"><Users size={18} className="text-primary" /> Member</h2>
        <p className="text-xs text-muted-foreground mt-1">Akun member hanya dapat dibuat oleh admin. Admin dapat mengelola nama, departemen, dan password member.</p>
        <Button type="button" className="rounded-none mt-3" onClick={() => { setSelected(null); setFormOpen(true); }}>Tambah Akun Departemen</Button>
      </div>
      {loading ? <p className="text-sm text-muted-foreground py-6">Memuat member...</p> : (
        <UserTable users={users} emptyText="Belum ada member." renderActions={(account) => <>
          <Button variant="outline" size="sm" className="rounded-none" onClick={() => { setSelected(account); setFormOpen(true); }}>Edit</Button>
          <ResetPasswordDialog account={account} />
          <DeleteUserDialog account={account} onDelete={remove} />
        </>} />
      )}
      <MemberFormDialog account={selected} open={formOpen} onOpenChange={setFormOpen} onSave={save} saving={saving} />
    </section>
  );
}
